var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "p",
        {
          staticClass: "text-center lead",
          staticStyle: { "font-size": "1.5rem" },
        },
        [
          _vm._v("\n        In the context of "),
          _c(
            "a",
            {
              staticClass: "text-primary",
              attrs: { title: "Show details" },
              on: { click: _vm.showCriterionDetails },
            },
            [_vm._v(_vm._s(_vm.contextName))]
          ),
          _vm._v(",\n        which alternative do you prefer: "),
          _c("br"),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "text-primary",
              attrs: { title: "Show details" },
              on: { click: _vm.showFirstAlternativeDetails },
            },
            [_vm._v(_vm._s(_vm.firstAlternativeName))]
          ),
          _vm._v(" or\n        "),
          _c(
            "a",
            {
              staticClass: "text-primary",
              attrs: { title: "Show details" },
              on: { click: _vm.showSecondAlternativeDetails },
            },
            [_vm._v(_vm._s(_vm.secondAlternativeName))]
          ),
          _vm._v("?\n    "),
        ]
      ),
      _vm._v(" "),
      _vm.isMeetingManager === true
        ? [
            _c("div", { staticClass: "card card-collapsable mt-1" }, [
              _c(
                "div",
                {
                  staticClass: "card-header pointer",
                  attrs: { "data-toggle": "collapse", href: "#cardQuestion" },
                },
                [_vm._v("\n                Group vote\n            ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "card-body collapse show pt-4",
                  attrs: { id: "cardQuestion" },
                },
                [
                  _c("div", { staticClass: "PairwiseComparisonEditor" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "mt1 ItemDetailsBox bg-color-blue3",
                            },
                            [
                              _c("h4", [
                                _vm._v(_vm._s(_vm.firstAlternativeName)),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "btn-group ItemButton" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-block dropdown-toggle",
                                class:
                                  _vm.FirstSelected === true
                                    ? "btn-success"
                                    : "btn-outline-secondary",
                                attrs: {
                                  type: "button",
                                  "data-toggle": "dropdown",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-regular",
                                  class:
                                    _vm.FirstSelected === true
                                      ? "fa-square-check"
                                      : "fa-square",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.FirstBtnLabel) +
                                    "\n                                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-menu" }, [
                              _c("h4", { staticClass: "dropdown-header" }, [
                                _vm._v("How strong is your preference?"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateValue(2)
                                    },
                                  },
                                },
                                [_vm._v("Weak (2)")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateValue(3)
                                    },
                                  },
                                },
                                [_vm._v("Moderate (3)")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateValue(4)
                                    },
                                  },
                                },
                                [_vm._v("Moderate + (4)")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateValue(5)
                                    },
                                  },
                                },
                                [_vm._v("Strong (5)")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateValue(6)
                                    },
                                  },
                                },
                                [_vm._v("Strong + (6)")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateValue(7)
                                    },
                                  },
                                },
                                [_vm._v("Very strong (7)")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateValue(8)
                                    },
                                  },
                                },
                                [_vm._v("Very strong + (8)")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateValue(9)
                                    },
                                  },
                                },
                                [_vm._v("Extreme (9)")]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12" },
                        [
                          _c(
                            "div",
                            { staticClass: "mt1 ItemDetailsBox bg-color-red3" },
                            [
                              _c("h4", [
                                _vm._v(_vm._s(_vm.secondAlternativeName)),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "btn-group ItemButton" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-block dropdown-toggle",
                                class:
                                  _vm.SecondSelected === true
                                    ? "btn-success"
                                    : "btn-outline-secondary",
                                attrs: {
                                  type: "button",
                                  "data-toggle": "dropdown",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-regular",
                                  class:
                                    _vm.SecondSelected === true
                                      ? "fa-square-check"
                                      : "fa-square",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.SecondBtnLabel) +
                                    "\n                                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-menu" }, [
                              _c("h4", { staticClass: "dropdown-header" }, [
                                _vm._v("How strong is your preference?"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateValue(1.0 / 2.0)
                                    },
                                  },
                                },
                                [_vm._v("Weak (2)")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateValue(1.0 / 3.0)
                                    },
                                  },
                                },
                                [_vm._v("Moderate (3)")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateValue(1.0 / 4.0)
                                    },
                                  },
                                },
                                [_vm._v("Moderate + (4)")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateValue(1.0 / 5.0)
                                    },
                                  },
                                },
                                [_vm._v("Strong (5)")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateValue(1.0 / 6.0)
                                    },
                                  },
                                },
                                [_vm._v("Strong + (6)")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateValue(1.0 / 7.0)
                                    },
                                  },
                                },
                                [_vm._v("Very strong (7)")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateValue(1.0 / 8.0)
                                    },
                                  },
                                },
                                [_vm._v("Very strong + (8)")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateValue(1.0 / 9.0)
                                    },
                                  },
                                },
                                [_vm._v("Extreme (9)")]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-sm-6 offset-sm-3 col-xs-12",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-block btn-equal mt1",
                              class:
                                _vm.EqualitySelected === true
                                  ? "btn-success"
                                  : "btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.updateValue(1.0)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-regular",
                                class:
                                  _vm.EqualitySelected === true
                                    ? "fa-square-check"
                                    : "fa-square",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("Equally preferred (1)")]),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-sm-6 offset-sm-3 col-xs-12",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-block mt1",
                              class:
                                _vm.value == null
                                  ? "btn-success"
                                  : "btn-outline-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.updateValue(null)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-regular",
                                class:
                                  _vm.value == null
                                    ? "fa-square-check"
                                    : "fa-square",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(
                                "\n                                Follow the average (default)\n                            "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-top": "30px" } }, [
                      _c("h5", { staticStyle: { "margin-bottom": "5px" } }, [
                        _vm._v("Comment:"),
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        staticClass: "form-control",
                        attrs: { rows: "5", placeholder: "Comment..." },
                        domProps: { value: _vm.comment },
                        on: {
                          input: function ($event) {
                            return _vm.updateComment($event.target.value)
                          },
                        },
                      }),
                    ]),
                  ]),
                ]
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isMeetingManager === false
        ? [
            _c("div", { staticClass: "PairwiseComparisonEditor" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12" },
                  [
                    _c(
                      "div",
                      { staticClass: "mt1 ItemDetailsBox bg-color-blue3" },
                      [_c("h4", [_vm._v(_vm._s(_vm.firstAlternativeName))])]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "btn-group ItemButton" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-block dropdown-toggle",
                          class:
                            _vm.FirstSelected === true
                              ? "btn-success"
                              : "btn-outline-secondary",
                          attrs: { type: "button", "data-toggle": "dropdown" },
                        },
                        [
                          _c("i", {
                            staticClass: "fa-regular",
                            class:
                              _vm.FirstSelected === true
                                ? "fa-square-check"
                                : "fa-square",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.FirstBtnLabel) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "dropdown-menu" }, [
                        _c("h4", { staticClass: "dropdown-header" }, [
                          _vm._v("How strong is your preference?"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown-divider" }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.updateValue(2)
                              },
                            },
                          },
                          [_vm._v("Weak (2)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.updateValue(3)
                              },
                            },
                          },
                          [_vm._v("Moderate (3)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.updateValue(4)
                              },
                            },
                          },
                          [_vm._v("Moderate + (4)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.updateValue(5)
                              },
                            },
                          },
                          [_vm._v("Strong (5)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.updateValue(6)
                              },
                            },
                          },
                          [_vm._v("Strong + (6)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.updateValue(7)
                              },
                            },
                          },
                          [_vm._v("Very strong (7)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.updateValue(8)
                              },
                            },
                          },
                          [_vm._v("Very strong + (8)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.updateValue(9)
                              },
                            },
                          },
                          [_vm._v("Extreme (9)")]
                        ),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12" },
                  [
                    _c(
                      "div",
                      { staticClass: "mt1 ItemDetailsBox bg-color-red3" },
                      [_c("h4", [_vm._v(_vm._s(_vm.secondAlternativeName))])]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "btn-group ItemButton" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-block dropdown-toggle",
                          class:
                            _vm.SecondSelected === true
                              ? "btn-success"
                              : "btn-outline-secondary",
                          attrs: { type: "button", "data-toggle": "dropdown" },
                        },
                        [
                          _c("i", {
                            staticClass: "fa-regular",
                            class:
                              _vm.SecondSelected === true
                                ? "fa-square-check"
                                : "fa-square",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.SecondBtnLabel) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "dropdown-menu" }, [
                        _c("h4", { staticClass: "dropdown-header" }, [
                          _vm._v("How strong is your preference?"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown-divider" }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.updateValue(1.0 / 2.0)
                              },
                            },
                          },
                          [_vm._v("Weak (2)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.updateValue(1.0 / 3.0)
                              },
                            },
                          },
                          [_vm._v("Moderate (3)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.updateValue(1.0 / 4.0)
                              },
                            },
                          },
                          [_vm._v("Moderate + (4)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.updateValue(1.0 / 5.0)
                              },
                            },
                          },
                          [_vm._v("Strong (5)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.updateValue(1.0 / 6.0)
                              },
                            },
                          },
                          [_vm._v("Strong + (6)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.updateValue(1.0 / 7.0)
                              },
                            },
                          },
                          [_vm._v("Very strong (7)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.updateValue(1.0 / 8.0)
                              },
                            },
                          },
                          [_vm._v("Very strong + (8)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                return _vm.updateValue(1.0 / 9.0)
                              },
                            },
                          },
                          [_vm._v("Extreme (9)")]
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-sm-6 offset-sm-3 col-xs-12",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block btn-equal mt1",
                        class:
                          _vm.EqualitySelected === true
                            ? "btn-success"
                            : "btn-outline-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.updateValue(1.0)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-regular",
                          class:
                            _vm.EqualitySelected === true
                              ? "fa-square-check"
                              : "fa-square",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Equally preferred (1)")]),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-sm-6 offset-sm-3 col-xs-12",
                  },
                  [
                    _vm.value != null
                      ? _c("div", { staticClass: "text-center" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-link mt1",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.updateValue(null)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-times",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(" Clear answer\n                        "),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { "margin-top": "30px" } }, [
                _c("h5", { staticStyle: { "margin-bottom": "5px" } }, [
                  _vm._v("Comment:"),
                ]),
                _vm._v(" "),
                _c("textarea", {
                  staticClass: "form-control",
                  attrs: { rows: "5", placeholder: "Comment..." },
                  domProps: { value: _vm.comment },
                  on: {
                    input: function ($event) {
                      return _vm.updateComment($event.target.value)
                    },
                  },
                }),
              ]),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isMeetingManager === true || _vm.votesEntries?.length
        ? _c(
            "div",
            {
              staticClass: "PairwiseComparisonVotesBrowserView mt-4",
              staticStyle: { "min-height": "500px" },
            },
            [
              _c("ul", { staticClass: "nav nav-tabs" }, [
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.VotesTabActive },
                      on: {
                        click: function ($event) {
                          _vm.ActiveTab = "votes"
                        },
                      },
                    },
                    [_vm._v("Votes")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.SummaryTabActive },
                      on: {
                        click: function ($event) {
                          _vm.ActiveTab = "summary"
                        },
                      },
                    },
                    [_vm._v("Chart")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.CommentsTabActive },
                      on: {
                        click: function ($event) {
                          _vm.ActiveTab = "notes"
                        },
                      },
                    },
                    [_vm._v("Comments")]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tab-content" }, [
                _vm.VotesTabActive
                  ? _c(
                      "div",
                      {
                        staticClass: "tab-pane pt-2",
                        class: { active: _vm.VotesTabActive },
                      },
                      [
                        _c("div", { staticClass: "table-responsive" }, [
                          _c("table", { staticClass: "table table-striped" }, [
                            _c("thead", [
                              _c("tr", [
                                _c("th", {
                                  staticStyle: { "border-top": "0" },
                                }),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticClass: "clearfix",
                                    staticStyle: {
                                      "min-width": "510px",
                                      "border-top": "0",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "clearfix pull-right",
                                        staticStyle: { width: "85%" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "pull-left" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.firstAlternativeName
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "pull-right" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.secondAlternativeName
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "text-center",
                                            staticStyle: {
                                              margin: "0 auto",
                                              width: "50px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            vs\n                                        "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              [
                                _c(
                                  "tr",
                                  { staticStyle: { "text-align": "center" } },
                                  [
                                    _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            "Average (" +
                                              _vm._s(_vm.AverageDescription) +
                                              ")"
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { padding: "0" } },
                                      [
                                        _c(
                                          "ul",
                                          {
                                            staticClass: "clearfix",
                                            staticStyle: {
                                              "list-style": "none",
                                              margin: "0",
                                              padding: "0",
                                            },
                                          },
                                          _vm._l(
                                            _vm.ScaleView1,
                                            function (scaleValue) {
                                              return _c(
                                                "li",
                                                {
                                                  class: _vm.GetCssClass(
                                                    scaleValue,
                                                    _vm.Average
                                                  ),
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm.GetScaleItemText(
                                                          scaleValue,
                                                          _vm.Average
                                                        )
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.VotesEntriesView, function (e) {
                                  return _c(
                                    "tr",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _c(
                                        "td",
                                        {
                                          staticStyle: { "text-align": "left" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                e.VotesSourceName ?? "???"
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticStyle: { padding: "0" } },
                                        [
                                          _c(
                                            "ul",
                                            {
                                              staticClass: "clearfix",
                                              staticStyle: {
                                                "list-style": "none",
                                                margin: "0",
                                                padding: "0",
                                              },
                                            },
                                            _vm._l(
                                              _vm.ScaleView1,
                                              function (scaleValue) {
                                                return _c(
                                                  "li",
                                                  {
                                                    class: _vm.GetCssClass(
                                                      scaleValue,
                                                      e.Value
                                                    ),
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.GetScaleItemText(
                                                            scaleValue,
                                                            e.Value
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.SummaryTabActive
                  ? _c(
                      "div",
                      {
                        staticClass: "tab-pane pt-2",
                        class: { active: _vm.SummaryTabActive },
                      },
                      [
                        _c("div", { staticClass: "table-responsive" }, [
                          _c("table", { staticClass: "table" }, [
                            _c("tbody", [
                              _c(
                                "tr",
                                {
                                  staticClass: "bottom noborder",
                                  staticStyle: { "text-align": "center" },
                                },
                                _vm._l(_vm.HistogramValues, function (v) {
                                  return _c(
                                    "td",
                                    {
                                      key: v.Value,
                                      staticStyle: {
                                        height: "400px",
                                        border: "none",
                                        "padding-top": "20px",
                                      },
                                    },
                                    [
                                      v.Count
                                        ? _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(v.Count),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "bg-color-blue2",
                                        class: _vm.GetColor(v.Value),
                                        style: { height: v.PercentOfMax + "%" },
                                      }),
                                    ]
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c(
                                "tr",
                                { staticStyle: { "text-align": "center" } },
                                _vm._l(_vm.HistogramValues, function (v) {
                                  return _c(
                                    "td",
                                    {
                                      key: v.Value,
                                      staticStyle: { width: "6%" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm
                                              .FormatValue(v.Value)
                                              .toFixedIfNeeded(2)
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            _c("tfoot", [
                              _c("tr", [
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: {
                                      colspan: _vm.LeftScaleValuesCount,
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.firstAlternativeName))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  { staticStyle: { "text-align": "center" } },
                                  [_vm._v("vs")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "right" },
                                    attrs: {
                                      colspan: _vm.RightScaleValuesCount,
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.secondAlternativeName))]
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.CommentsTabActive
                  ? _c(
                      "div",
                      {
                        staticClass: "tab-pane pt-2",
                        class: { active: _vm.CommentsTabActive },
                      },
                      _vm._l(_vm.Comments, function (c) {
                        return _c("blockquote", { staticClass: "blockquote" }, [
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(_vm._s(c.Comment)),
                          ]),
                          _vm._v(" "),
                          _c("footer", { staticClass: "blockquote-footer" }, [
                            _vm._v(_vm._s(c.VotesSourceName ?? "???")),
                          ]),
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }